var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMailSent(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 30.5006V69.5006H69.63V30.5006L35.5 1.64062L2 30.5006Z",
    stroke: "url(#paint0_linear_1505_40032)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 30.5L24.58 49.74",
    stroke: "url(#paint1_linear_1505_40032)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M69.58 30.5L47 49.74",
    stroke: "url(#paint2_linear_1505_40032)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 40V12H13.5V40",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5 40V12H13.5V40",
    stroke: "url(#paint3_linear_1505_40032)",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 20H39.5",
    stroke: "url(#paint4_linear_1505_40032)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 27H44.5",
    stroke: "url(#paint5_linear_1505_40032)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 34H49.5",
    stroke: "url(#paint6_linear_1505_40032)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26C63.9036 26 69.5 20.4036 69.5 13.5C69.5 6.59644 63.9036 1 57 1C50.0964 1 44.5 6.59644 44.5 13.5C44.5 20.4036 50.0964 26 57 26Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M57 26C63.9036 26 69.5 20.4036 69.5 13.5C69.5 6.59644 63.9036 1 57 1C50.0964 1 44.5 6.59644 44.5 13.5C44.5 20.4036 50.0964 26 57 26Z",
    stroke: "url(#paint7_linear_1505_40032)",
    strokeWidth: 2
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M50.5 15L55 19.5L63.5 10",
    stroke: "url(#paint8_linear_1505_40032)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M2 69.5004L35.82 39.9004L69.63 69.5004",
    stroke: "url(#paint9_linear_1505_40032)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1505_40032",
    x1: 11.7207,
    y1: 4.55593,
    x2: 51.3769,
    y2: 49.5731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1505_40032",
    x1: 5.24551,
    y1: 31.3266,
    x2: 16.1183,
    y2: 45.8611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1505_40032",
    x1: 50.2455,
    y1: 31.3266,
    x2: 61.1183,
    y2: 45.8611,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1505_40032",
    x1: 19.8243,
    y1: 13.2029,
    x2: 33.8704,
    y2: 38.3445,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1505_40032",
    x1: 23.2309,
    y1: 20.043,
    x2: 23.2853,
    y2: 21.2186,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1505_40032",
    x1: 23.9496,
    y1: 27.043,
    x2: 23.9927,
    y2: 28.2196,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1505_40032",
    x1: 24.6683,
    y1: 34.043,
    x2: 24.7039,
    y2: 35.2201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1505_40032",
    x1: 48.0933,
    y1: 2.07401,
    x2: 62.6966,
    y2: 18.7078,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1505_40032",
    x1: 52.3685,
    y1: 10.4081,
    x2: 57.4555,
    y2: 18.3372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1505_40032",
    x1: 11.7207,
    y1: 41.172,
    x2: 23.397,
    y2: 71.5594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1092,
    stopColor: "#9B01B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9139,
    stopColor: "#D6248E"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMailSent);
export default __webpack_public_path__ + "static/media/mail-sent.1751572d.svg";
export { ForwardRef as ReactComponent };